import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import React from 'react';
import { convert_dd_mm_yy_to_milliseconds } from './utils/util';
import { handle_backlog_completion_date_update } from '../../../../redux/po_backlog/backlog.action';
import { useDispatch, useSelector } from 'react-redux';
import { get_po_backlog_state } from '../../../../redux/po_backlog/backlog.selector';

const CustomDateTimePicker = ({ row, field }) => {
  const dispatch = useDispatch();
  const backlog = useSelector(get_po_backlog_state);
  return (
    <>
      <DatePicker format='DD/MM/YYYY' disablePast={!row[field] ? true : false} readOnly={row[field] ? true : false} defaultValue={row[field] && dayjs((() => {
        if (row[field]) {
          return convert_dd_mm_yy_to_milliseconds(row[field]);
        }
      })())}
        onChange={(e) => {
          console.log("changed", e);
          dispatch(handle_backlog_completion_date_update(backlog, e, row, row.id));
        }}
      />
    </>
  );
};

export default CustomDateTimePicker;